import React, { useState } from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import { useMutation } from 'react-query'
import profileSettingsCloseAccountStyles from './profileSettingsCloseAccount.styles'
import DeleteConfirmationModal from '../../../components/ui/DeleteConfirmationModal/DeleteConfirmationModal'
import disableUserAccount from '../../../Apis/user/disableUserAccount'
import TextButton from '../../../components/ui/TextButton/TextButton'
import useHistoryPush from '../../../hooks/useHistoryPush'
import ContainerPadding from '../../../components/containerPadding/containerPadding'

const ProfileSettingsCloseAccount = () => {
  const [disableAccountModal, setDisableAccountModal] = useState(false)
  const translate = useTranslate()
  const { redirect } = useHistoryPush()
  const useStyles = makeStyles(profileSettingsCloseAccountStyles)
  const classes = useStyles()

  const disableAccount = useMutation((data) => disableUserAccount(data), {
    onSuccess: () => {
      redirect('/login')
    },
  })

  const onSubmit = (data) => {
    const { name } = data
    disableAccount.mutate({
      password: name,
    })
  }

  return (
    <ContainerPadding padding='3% 1% 3% 1%'>
      <div className={classes.disableWrapper}>
        <Typography className={classes.cardTitle} variant='h6'>
          {translate('ra.text.closeAccount')}
        </Typography>
        <TextButton
          onClick={() => setDisableAccountModal(true)}
          label={translate('ra.buttons.delete')}
          className={classes.disableButtonRoot}
        />
      </div>
      <Typography className={classes.subtitle} variant='subtitle1'>
        {translate('ra.text.disableAccountDataLost')}
      </Typography>
      <DeleteConfirmationModal
        isModalOpen={disableAccountModal}
        onClose={() => setDisableAccountModal(false)}
        title={translate('ra.text.disableAccount')}
        subtitle={translate('ra.text.insertPassword')}
        comparisonValue=''
        buttonLabel={translate('ra.buttons.disableAccount')}
        textFieldLabel={translate('ra.formFields.password')}
        onSubmit={onSubmit}
        isPassword
        isLoading={disableAccount.isLoading}
        importantMessage={translate('ra.text.orgOwner')}
      />
    </ContainerPadding>
  )
}
export default ProfileSettingsCloseAccount
